


































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { filter, includes, isArray, isEmpty, some } from 'lodash';
import {
  SearchCondition,
  SearchRule,
  DisabledDate,
} from '@/models/flight-search';

@Component({
  components: {},
})
export default class DepartureArrival extends Vue {
  private dateRange = '';
  private dateChangebirthday(event) {
    this.$emit('change', event)
    alert(this.dateRange);
  }
}
